import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, ArrowRight } from 'lucide-react';
import { Button } from '../../components/ui/Button';
import { Card } from '../../components/ui/Card';
import { DjayAvatar } from '../../mascot';
import type { AssessmentReport } from '../types';
interface AssignedAssessmentCompleteScreenProps {
  report: AssessmentReport;
  onExit: () => void;
}
export function AssignedAssessmentCompleteScreen({
  report,
  onExit
}: AssignedAssessmentCompleteScreenProps) {
  const totalQuestions = report.score.totalQuestions;
  const correctCount = report.score.correctCount;
  const score = report.score.percentage;
  return <div className="min-h-screen bg-gradient-to-b from-orange-50 to-white flex items-center justify-center p-4" data-id="element-1056">
      <motion.div initial={{
      opacity: 0,
      scale: 0.9,
      y: 20
    }} animate={{
      opacity: 1,
      scale: 1,
      y: 0
    }} transition={{
      duration: 0.5,
      ease: 'easeOut'
    }} className="w-full max-w-md" data-id="element-1057">
        <Card className="p-8 text-center shadow-lg border-orange-100" data-id="element-1058">
          <motion.div initial={{
          scale: 0
        }} animate={{
          scale: 1
        }} transition={{
          delay: 0.2,
          type: 'spring',
          stiffness: 200,
          damping: 15
        }} className="mb-6" data-id="element-1059">
            <DjayAvatar size="lg" emotion="excited" animate data-id="element-1060" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.4
        }} data-id="element-1061">
            <div className="inline-flex items-center justify-center w-14 h-14 bg-green-100 rounded-full mb-4" data-id="element-1062">
              <CheckCircle2 className="w-8 h-8 text-green-600" data-id="element-1063" />
            </div>

            <h1 className="text-2xl font-black text-slate-900 mb-2" data-id="element-1064">
              Toets klaar! 🎉
            </h1>
            <p className="text-slate-600 mb-6" data-id="element-1065">
              Goed gedaan! Je hebt de toets afgerond.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.6
        }} className="bg-slate-50 rounded-xl p-4 mb-6" data-id="element-1066">
            <div className="grid grid-cols-2 gap-4" data-id="element-1067">
              <div data-id="element-1068">
                <div className="text-2xl font-black text-orange-600" data-id="element-1069">
                  {Math.round(score)}%
                </div>
                <div className="text-xs font-medium text-slate-500 mt-0.5" data-id="element-1070">
                  Score
                </div>
              </div>
              <div data-id="element-1071">
                <div className="text-2xl font-black text-slate-800" data-id="element-1072">
                  {correctCount}/{totalQuestions}
                </div>
                <div className="text-xs font-medium text-slate-500 mt-0.5" data-id="element-1073">
                  Goed beantwoord
                </div>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.8
        }} data-id="element-1074">
            <p className="text-sm text-slate-500 mb-5" data-id="element-1075">
              Je docent kan de resultaten bekijken in het leerkrachtportaal.
            </p>

            <Button onClick={onExit} className="w-full bg-orange-500 hover:bg-orange-600 text-white shadow-sm" size="lg" data-id="element-1076">
              Terug naar home
              <ArrowRight className="w-4 h-4 ml-2" data-id="element-1077" />
            </Button>
          </motion.div>
        </Card>
      </motion.div>
    </div>;
}